module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkAQMAAABKLAcXAAAABlBMVEX19/nX19e/StMfAAAASklEQVQ4y2M4b/MZji4wNDAggAADAx5eAwofN09g1EyyzUzAwhNA4zHg4eE2ZQibyf4fCP7ATEHlDXe/k2TmaD4aXGZ+RipqPwAAN6JO75aqgC4AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/notAddImg.png
// module id = 1567
// module chunks = 2